<template name="dialog-confirm">
	<div class="product-confirm-dialog">
		<el-dialog width="567px" title="模板使用情况" :visible.sync="show" :before-close="close" :close-on-click-modal='false'>
			<div class="blue_blo">
				<p style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 1;width: 350px;">模板名称：{{template_name}}</p>
				<p style="margin-left: 30px;">使用商品：{{count}}个</p>
			</div>
			<div v-if="list.length > 0">
				<el-table :data="list"
							height="300"
							style="width: 100%" :show-header="false">
					<el-table-column label="标题" prop="title" width="378" align="left">
						<template slot-scope="scope">
							<div style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 1;">{{scope.row.title}}</div>
						</template>
					</el-table-column>
					
					<el-table-column label="操作" align="right">
					  <template slot-scope="scope">
							<div class="pop-button" @click="editProduct(scope.row.id)">
								<i class="el-icon-s-tools" style="margin-right: 2px;"></i>管理
							</div>
					  </template>
					</el-table-column>
				</el-table>
				
				<!-- 分页器 -->
				<div class="block" style="padding: 30px 30px 10px 30px;" v-if="list.length > 0">
					<el-pagination background align='center' @size-change="handleSizeChange"
						@current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
						layout="total, prev, pager, next, jumper" :pager-count='5' :total="count">
					</el-pagination>
				</div>
			</div>
			<div class="empty" v-else>
				<img src="../../assets/img/goods/empty_pop.png">
				<div>当前暂无商品在使用该模版</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getRelatedProductInfo
	} from '@/api/freight_template';
import _default from 'vuex';
	export default {
		data() {
			return {
				list:[],
				count: 0,
				pageSize: 10,
				currentPage: 1,
			};
		},
		props: {
			show: {
				type: Boolean,
				default: false
			},
			freight_id: {
				type: Number,
				default: 0,
			},
			freight_idx: {
				type: Number,
				default: 0,
			},
			template_name:{
				type: String,
				default: '---',
			},
		},
		watch:{
			show: function(newVal, oldVal){
				if(newVal){
					this.getInfo();
				}
			}
		},
		methods: {
			close() {
				this.list = [];
				this.$emit('close');
			},
			getInfo() {
				getRelatedProductInfo({
					freight_id: this.freight_id,
					page:this.currentPage,
					pageSize:this.pageSize
				}).then(res => {
					if (res.code == 0) {
						this.list = res.data.list;
						this.count = res.data.allcount;
					} else {
						this.close();
						this.$emit('remove',this.freight_idx);
						this.$message.error(res.message);
					}
				})
			},
			//每页条数改变时触发 选择一页显示多少行
			handleSizeChange(val) {
				this.currentPage = 1;
				this.pageSize = val;
			},
			//当前页改变时触发 跳转其他页
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getInfo();
			},
			editProduct(product_id){
				this.$router.push({
					path: '/product/publish',
					query: {
						product_id: product_id
					}
				});
			}
		},
		mounted() {
		}
	}
</script>

<style scoped>
	.blue_blo{
		width: 100%;
		height: 30px;
		line-height: 30px;
		background: #E6F1FC;
		border-radius: 4px;
		padding-left: 5px;
		display: inline-flex;
		font-size: 12px;
		font-weight: 400;
		color: #333333;
	}
	.pop-button {
		margin-left: 10px;
		line-height: 17px;
		cursor: pointer;
		font-size: 14px;
		color: #409EFF;
		float: right;
	}
	.el-table .cell {
		padding-right: 0 !important;
		padding-left: 0 !important;
	}
	
	.empty {
		width: 100%;
		height: 400px;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}
	.empty img {
		width: 126px;
		height: 140px;
	}
	.empty div {
		margin-top: 10px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #999999;
		line-height: 17px;
	}
</style>